import React from "react";
import { useLang } from "../../translations";
import { FadeUp, Stagger, StaggerItem } from "./Reveal";

const VIALS = "https://images.unsplash.com/photo-1565033624234-3fcd6717568a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export const Journey = () => {
  const { t } = useLang();
  return (
    <section id="journey" data-testid="journey-section" className="relative py-24 md:py-36 bg-ink text-cream overflow-hidden">
      <img src={VIALS} alt="" className="absolute inset-0 h-full w-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-ink/70" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <FadeUp>
          <p className="text-xs uppercase tracking-[0.28em] text-sage mb-4">{t.journey.label}</p>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-[3.4rem] leading-[1.05] tracking-tight max-w-2xl">
            {t.journey.title}
          </h2>
        </FadeUp>

        <Stagger className="mt-16 grid md:grid-cols-3 gap-px bg-cream/15 rounded-2xl overflow-hidden">
          {t.journey.steps.map((s, i) => (
            <StaggerItem key={i} className="bg-ink">
              <div data-testid={`journey-step-${i}`} className="h-full p-8 md:p-10 relative">
                <span className="font-heading text-6xl md:text-7xl text-sage/60">{s.n}</span>
                <h3 className="font-heading text-2xl md:text-3xl mt-4">{s.t}</h3>
                <p className="mt-4 text-cream/70 leading-relaxed">{s.d}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
